export default "__VITE_ASSET__DRL6I5wd__"